import React from "react";
import styles from "./GroupItem.module.scss";
import { ActionIcon, type ActionIconProps, TextInput } from "@mantine/core";

export const GroupItemContainer: React.FC<
  { active?: boolean } & React.HTMLAttributes<HTMLDivElement>
> = ({ active, children, className, ...rest }) => (
  <div
    className={`${styles.groupItemContainer} ${active ? styles.active : ""} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
);

export const GroupNameInput: React.FC<
  React.ComponentProps<typeof TextInput>
> = props => <TextInput className={styles.groupNameInput} {...props} />;

export const DeleteBox: React.FC<ActionIconProps> = props => (
  <ActionIcon className={styles.deleteBox} {...props} />
);
